import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, replace } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { Toast } from 'antd-mobile'
import { isPayBy, getUUID } from 'utils'
import _ from 'lodash'
import { getAppSalt } from 'store/siteConfig'
import { encrypt } from 'utils/rsa'

// ------------------------------------
// Constants
// ------------------------------------
export const VOUCHER_SHARE_INVITEE = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    COLLECT_REQUEST: null,
    COLLECT_SUCCESS: null,
    REMOVE_TIPS_INFO: null,
    REMOVE_BIZ_DATA: null
  },
  'VOUCHER_SHARE_INVITEE'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: `cgs/event/member-share/v1/${
          isPayBy() ? 'auth' : 'unauth'
        }/collect/init`,
        method: 'POST',
        body: data,
        requestAction: VOUCHER_SHARE_INVITEE.INIT_REQUEST,
        successAction: VOUCHER_SHARE_INVITEE.INIT_SUCCESS,
        success: function(result) {
          const { bizData = {} } = result.commandData
          if (bizData.activityStatus === 'N') {
            dispatch(replace('/voucher/share/expired?campaign=voucher_share_invitee'))
          }
        }
      })
    )
  }
}

export function collect(data, header) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: `cgs/event/member-share/v1/${isPayBy() ? 'auth' : 'unauth'}/collect`,
        method: 'POST',
        body: data,
        header,
        requestAction: VOUCHER_SHARE_INVITEE.COLLECT_REQUEST,
        successAction: VOUCHER_SHARE_INVITEE.COLLECT_SUCCESS,
        success: function(result) {
          Toast.hide()
          // typeof callback === 'function' && callback(result.commandData)
        }
      })
    )
  }
}

export function submit(data) {
  Toast.loading('', 0)
  return (dispatch) => {
    if (isPayBy()) {
      return dispatch(collect(data))
    }
    const saltKey = getUUID()
    dispatch(getAppSalt(saltKey)).then((res) => {
      const { salt } = res.payload
      const { mobileNo, ...restData } = data
      restData.mobileNo = encrypt(mobileNo.replace('-0', '-'), salt)
      dispatch(
        collect(restData, {
          'Salt-Key': saltKey
        })
      )
    })
  }
}

export function removeTipsInfo() {
  return (dispatch) => {
    dispatch({
      type: VOUCHER_SHARE_INVITEE.REMOVE_TIPS_INFO
    })
  }
}

export function removeBizData() {
  return (dispatch) => {
    dispatch({
      type: VOUCHER_SHARE_INVITEE.REMOVE_BIZ_DATA
    })
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [VOUCHER_SHARE_INVITEE.INIT_REQUEST]: (state, action) => state,
  [VOUCHER_SHARE_INVITEE.INIT_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    return Object.assign({}, state, action.payload, { ...commandData })
  },
  [VOUCHER_SHARE_INVITEE.COLLECT_REQUEST]: (state, action) => state,
  [VOUCHER_SHARE_INVITEE.COLLECT_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    if (_.get(commandData, 'bizData.couponAmount')) {
      commandData.bizData.receiveStatus = 'Y' // 首次领取成功
    }
    state.bizData = Object.assign({}, state.bizData, commandData.bizData)
    return Object.assign({}, state, { tipsInfo: commandData.tipsInfo })
  },
  [VOUCHER_SHARE_INVITEE.REMOVE_TIPS_INFO]: (state, action) => {
    return Object.assign({}, state, {
      tipsInfo: {}
    })
  },
  [VOUCHER_SHARE_INVITEE.REMOVE_BIZ_DATA]: (state, action) => {
    state.bizData.receiveStatus = 'N'
    state.bizData.couponAmount = {}
    return Object.assign({}, state)
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'voucherShareInvitee',
    reducerMap: {
      voucherShareInviteeState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
